import { HorizontalStack, VerticalStack } from "../../Stack";
import { useState, ReactNode } from "react";
import PdfIcon from "../../../assets/Icons/svg/pdfIcon";
import { Document } from "../../../models";
import { EmailNotesHoverCard } from "../HoverCard";

interface PdfIconWithTooltipProps {
  documentLink?: string;
  children?: ReactNode;
  props?: Document;
}

const PdfIconWithTooltip = ({ documentLink, children, props }: PdfIconWithTooltipProps) => {
  const [pdfToolTip, setPdfToolTip] = useState("none");
  
  return (
    <>
    <HorizontalStack style={{ alignItems: "center", gap: "0px", flexDirection: "column-reverse" }}>
      {children && (
        <VerticalStack style={{ gap: "4px", alignItems: "flex-start", flexDirection: "row", position: "relative" }}>
          {children}
          <div
            id="pdf"
            data-testid="pdf-icon-wrapper"
            style={{ position: "relative" }}
            onClick={(event) => {
              window.open(documentLink);
              event.stopPropagation();
            }}
            onMouseEnter={() => {
              setPdfToolTip("flex");
            }}
            onMouseLeave={() => {
              setPdfToolTip("none");
            }}
          >
            <PdfIcon />
            <img
              alt=""
              width={64}
              height={22}
              src={require("../../../assets/Icons/ViewPDF.png")}
              style={{ 
                display: pdfToolTip,
                position: "absolute",
                top: "0px",
                left: "0%",
                transform: "translateX(-130%)",
                zIndex: 1000,
                pointerEvents: "none"
              }}
            />
          </div>
        </VerticalStack>
      )}
      {!children && (
        <div
          id="pdf"
          data-testid="pdf-icon-wrapper"
          style={{ position: "relative" }}
          onClick={(event) => {
            window.open(documentLink);
            event.stopPropagation();
          }}
          onMouseEnter={() => {
            setPdfToolTip("flex");
          }}
          onMouseLeave={() => {
            setPdfToolTip("none");
          }}
        >
          <PdfIcon />
          <img
            alt=""
            width={64}
            height={22}
            src={require("../../../assets/Icons/ViewPDF.png")}
            style={{ 
              display: pdfToolTip,
              position: "absolute",
              top: "0px",
              left: "75%",
              transform: "translateX(-130%)",
              zIndex: 1000,
              pointerEvents: "none"
            }}
          />
        </div>
      )}
    </HorizontalStack>
    </>
  );
};

export default PdfIconWithTooltip;